import React from 'react';

export default function ArrowRightIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="Vector 3" d="M-5.08922e-07 2.35723L-1.03038e-07 11.6428C-5.44407e-08 12.7545 1.14104 13.5008 2.1596 13.0552L12.7716 8.41241C14.0033 7.87356 14.0033 6.12644 12.7716 5.58759L2.1596 0.944824C1.14103 0.499204 -5.57519e-07 1.24546 -5.08922e-07 2.35723Z" fill="currentColor" />
    </svg>
  );
}
